import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import HolidaysListingViewModel from "./HolidaysListingViewModel";

const HolidaysListing = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    HolidaysArray,
    IsLoading,
  } = HolidaysListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-holidays-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Holidays</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/admin/dashboard`}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Holidays</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Holidays</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to={`/user/admin/holidays/add`}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>ID</th>
                            <th>Holiday Name</th>
                            <th>Type</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {HolidaysArray &&
                            HolidaysArray.map((item, index) => {
                              // Holidays Name Start
                              const ArrayOfHolidaysWords =
                                item?.HolidaysName.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfHolidaysWords.length;
                                i++
                              ) {
                                ArrayOfHolidaysWords[i] =
                                  ArrayOfHolidaysWords[i]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfHolidaysWords[i].slice(1);
                              }
                              const StringOfHolidaysWords =
                                ArrayOfHolidaysWords.join(" ");
                              // Holidays Name End

                              // Holidays Type Start
                              const ArrayOfTypeOfHolidaysWords =
                                item?.HolidaysType.split(" ");
                              for (
                                var j = 0;
                                j < ArrayOfTypeOfHolidaysWords.length;
                                j++
                              ) {
                                ArrayOfTypeOfHolidaysWords[j] =
                                  ArrayOfTypeOfHolidaysWords[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfTypeOfHolidaysWords[j].slice(1);
                              }
                              const StringOfTypeOfHolidaysWords =
                                ArrayOfTypeOfHolidaysWords.join(" ");
                              // Holidays Type End

                              return (
                                <tr key={index}>
                                  <td>{item?.HolidaysID}</td>
                                  <td>{StringOfHolidaysWords}</td>
                                  <td>{StringOfTypeOfHolidaysWords}</td>
                                  <td>{item?.HolidaysStartDate}</td>
                                  <td>{item?.HolidaysEndDate}</td>
                                  <td className="text-end">
                                    <div className="actions ">
                                      <Link
                                        onClick={() => {
                                          handleOpenDeleteDialog(item?.id);
                                        }}
                                        className="btn btn-sm bg-success-light me-2 "
                                      >
                                        <i className="fa-regular fa-trash-can"></i>
                                      </Link>
                                      <Link
                                        to={`/user/admin/holidays/update/${item?.id}`}
                                        className="btn btn-sm bg-danger-light"
                                      >
                                        <i className="fa-regular fa-pen-to-square"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {HolidaysArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this holidays?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </Fragment>
  );
};

export default HolidaysListing;
